import { NgModule } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DateAdapter, provideNativeDateAdapter } from '@angular/material/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { CoreModule } from '../core/core.module';
import {
  ArivoAccordionBodyComponent,
  ArivoAccordionComponent,
  ArivoAccordionHeaderComponent,
  ArivoAlertsComponent,
  ArivoBottomSheetDialogComponent,
  ArivoDialogComponent,
  ArivoDialogContainerComponent,
  ArivoLicensePlateComponent,
  ArivoLicensePlateInputComponent,
  ArivoLicensePlateInputDirective,
  ArivoPaginatorComponent,
  ArivoStepComponent,
  ArivoStepFooterComponent,
  ArivoStepperComponent,
  ArivoStepperNextDirective,
  ArivoStepperPreviousDirective,
  ArivoTabComponent,
  ArivoTabsComponent,
  ArivoToastComponent,
} from '@shared/components/ui-elements';
import {
  AddEmptyPlaceholderDirective,
  FormErrorDirective,
  FormErrorTextDirective,
  FormGroupDirective,
  HideIfNoTranslationDirective,
} from '@shared/directives';
import { DateDiffPipe, DateFnsPipe, DurationPipe } from '@shared/pipes';
import {
  BaseLayoutComponent,
  HeaderComponent,
  LoggedInLayoutComponent,
  PublicLayoutComponent,
  SidebarComponent,
} from '@shared/components/layouts';
import {
  ArivoLegalLinksComponent,
  ArivoMarketingConsentComponent,
  ArivoPaymentContainerComponent,
  ArivoPaymentIframeComponent,
} from '@shared/components';
import { ArivoDatepickerAdapter } from '@shared/utils';

@NgModule({
  declarations: [
    ArivoLicensePlateComponent,
    ArivoLicensePlateInputComponent,
    ArivoStepperComponent,
    ArivoStepComponent,
    ArivoStepFooterComponent,
    ArivoStepperPreviousDirective,
    ArivoStepperNextDirective,
    ArivoAccordionComponent,
    ArivoAccordionHeaderComponent,
    ArivoAccordionBodyComponent,
    FormErrorDirective,
    FormErrorTextDirective,
    FormGroupDirective,
    ArivoLicensePlateInputDirective,
    ArivoDialogComponent,
    ArivoBottomSheetDialogComponent,
    ArivoToastComponent,
    DateFnsPipe,
    ArivoAlertsComponent,
    ArivoTabsComponent,
    ArivoTabComponent,
    DurationPipe,
    DateDiffPipe,
    LoggedInLayoutComponent,
    PublicLayoutComponent,
    HeaderComponent,
    SidebarComponent,
    ArivoDialogContainerComponent,
    AddEmptyPlaceholderDirective,
    ArivoPaymentContainerComponent,
    ArivoPaginatorComponent,
    ArivoMarketingConsentComponent,
    ArivoLegalLinksComponent,
    BaseLayoutComponent,
    HideIfNoTranslationDirective,
    ArivoPaymentIframeComponent,
  ],
  imports: [CoreModule, MatTooltipModule, MatDatepickerModule, MatProgressSpinnerModule, MatIconModule],
  exports: [
    ArivoLicensePlateComponent,
    ArivoLicensePlateInputComponent,
    ArivoStepperComponent,
    ArivoStepComponent,
    ArivoStepFooterComponent,
    ArivoStepperPreviousDirective,
    ArivoStepperNextDirective,
    ArivoAccordionComponent,
    ArivoAccordionHeaderComponent,
    ArivoAccordionBodyComponent,
    FormErrorDirective,
    FormErrorTextDirective,
    FormGroupDirective,
    ArivoLicensePlateInputDirective,
    ArivoDialogComponent,
    MatInputModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatProgressSpinnerModule,
    ArivoBottomSheetDialogComponent,
    ArivoToastComponent,
    MatIconModule,
    DateFnsPipe,
    ArivoAlertsComponent,
    ArivoTabsComponent,
    ArivoTabComponent,
    DurationPipe,
    DateDiffPipe,
    LoggedInLayoutComponent,
    PublicLayoutComponent,
    AddEmptyPlaceholderDirective,
    ArivoPaymentContainerComponent,
    ArivoPaginatorComponent,
    ArivoMarketingConsentComponent,
    ArivoLegalLinksComponent,
    HideIfNoTranslationDirective,
    ArivoPaymentIframeComponent,
  ],
  providers: [provideNativeDateAdapter(), { provide: DateAdapter, useClass: ArivoDatepickerAdapter }],
})
export class SharedModule {}
